import PropTypes from 'prop-types';
import { Box, Card, Divider, Stack, Typography } from '@mui/material';
import Iconify from '../../../components/Iconify';

function WalletMetric({ label, value, accent = 'text.primary' }) {
  return (
    <Stack spacing={0.5}>
      <Typography variant="caption" sx={{ textTransform: 'uppercase', letterSpacing: 0.6 }} color="text.secondary">
        {label}
      </Typography>
      <Typography variant="h4" sx={{ color: accent, lineHeight: .9, fontWeight: 600 }}>
        {value}
      </Typography>
    </Stack>
  );
}

WalletMetric.propTypes = {
  accent: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default function WalletSummaryCard({
  title,
  icon,
  subtitle,
  primaryLabel,
  primaryValue,
  secondaryLabel,
  secondaryValue,
}) {
  return (
    <Card variant="outlined" sx={{ borderRadius: 2.5, height: '100%' }}>
      <Stack spacing={2.5} sx={{ p: 2.75 }}>
        <Stack direction="row" spacing={1.25} alignItems="center">
          <Box
            sx={{
              width: 42,
              height: 42,
              borderRadius: 2,
              display: 'grid',
              placeItems: 'center',
              bgcolor: 'grey.100',
              color: 'text.primary',
            }}
          >
            <Iconify icon={icon} width={20} height={20} />
          </Box>
          <Box>
            <Typography variant="subtitle1">{title}</Typography>
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          </Box>
        </Stack>

        <WalletMetric label={primaryLabel} value={primaryValue} accent="primary.main" />
        <Divider />
        <WalletMetric label={secondaryLabel} value={secondaryValue} />
      </Stack>
    </Card>
  );
}

WalletSummaryCard.propTypes = {
  icon: PropTypes.string.isRequired,
  primaryLabel: PropTypes.string.isRequired,
  primaryValue: PropTypes.string.isRequired,
  secondaryLabel: PropTypes.string.isRequired,
  secondaryValue: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
